import React, { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { useLocation, useNavigate } from 'react-router-dom';
import { get_single_owner_user_detail } from '../api/usersApi';
import "../../../../_metronic/assets/keenicons/duotone/style.css";
function ViewOwnerUserDetail() {
  const [ViewAllOrganisationUserDetail, setViewAllOrganisationUserDetail] = useState<any | null>();
  const [ViewUserDetail, setViewUserDetail] = useState<any | null>();
  const location = useLocation();
  const navigate = useNavigate();
  const user = (location.state as { user })?.user;

  const { data, isLoading, error } = useQuery(
    ['get_single_owner_user_detail'],
    () => user?.id ? get_single_owner_user_detail(user?.id) : Promise.reject("User ID is missing"),
    { refetchOnWindowFocus: false }
  );

  useEffect(() => {
    if (user) {
      setViewUserDetail(user); // Set the user data to the state
    }
  }, [user]);

  useEffect(() => {
    if (data) {
      setViewAllOrganisationUserDetail(data.data); // Set the organisation user details
    }
  }, [data]);

  // Render applications recursively without description
  const renderApplications = (applications) => {
    return (
      <ul className="list-group ms-3 mt-2">
        {applications.map((application) => (
          <li key={application.id} className="list-group-item list-group-item-light">
            <div className="d-flex justify-content-between">
              <strong>{application.name}</strong>
              <span className={`badge ${application.status === 1 ? 'bg-success' : 'bg-secondary'}`}>
                {application.status === 1 ? "Active" : "Inactive"}
              </span>
            </div>
          </li>
        ))}
      </ul>
    );
  };

  if (isLoading) {
    return (
      <div className='text-center'>
        <div className='spinner-border' role='status'>
          <span className='visually-hidden'>Loading...</span>
        </div>
      </div>
    );
  }
  if (error) {
    return <div>Error: {error instanceof Error ? error.message : "An unexpected error occurred"}</div>;
  }
  return (
    <div className="card card-custom mb-4">
      <div
        className="card-header border-0"
      >
        <h3 className="card-title align-items-start flex-column">
          <span className="card-label fw-bolder fs-3 mb-1">View Owner User Detail</span>
        </h3>
        <div
          className="card-toolbar"
          data-bs-toggle="tooltip"
          data-bs-placement="top"
        >
          <button
            data-toggle="tooltip" data-placement="bottom" title="Navigate to List of Users"
            className="btn btn-sm btn-light-dark fs-5"
            onClick={() => navigate("/owner-users/list-users")}
          >
            List of Users
          </button>
        </div>
      </div>

      <div className="card-body">
        {ViewUserDetail && (
                              <div className="row">
                              {/* Profile Picture */}
                              <div className="col-md-4 text-center mb-4 mb-md-0">
                                  {ViewUserDetail.profile_picture ? (
                                      <img
                                          src={ViewUserDetail.profile_picture}
                                         className="img-fluid edit-organisation-img rounded"
                                          alt="Profile"
                                      />
                                  ) : (
                                    <div className="symbol symbol-circle symbol-150px">
                                    <div className="symbol-label fs-1 fw-bold text-inverse-dark bg-dark">{ViewUserDetail.first_name ? ViewUserDetail.first_name[0].toUpperCase() : ''}</div>
                                </div>
                                  )}
                              </div>
      
                              {/* User Details */}
                              <div className="col-md-8">
                                  <div className="row mb-3">
                                      <label className="col-5 fw-bold fs-3">Email:</label>
                                      <div className="col-7 fs-3">{ViewUserDetail.email}</div>
                                  </div>
                                  <div className="row mb-3">
                                      <label className="col-5 fw-bold fs-3">First Name:</label>
                                      <div className="col-7 fs-3">{ViewUserDetail.first_name}</div>
                                  </div>
                                  <div className="row mb-3">
                                      <label className="col-5 fw-bold fs-3">Middle Name:</label>
                                      <div className="col-7 fs-3">
                                          {ViewUserDetail.middle_name || 'N/A'}
                                      </div>
                                  </div>
                                  <div className="row mb-3">
                                      <label className="col-5 fw-bold fs-3">Last Name:</label>
                                      <div className="col-7 fs-3">{ViewUserDetail.last_name}</div>
                                  </div>
                                  <div className="row mb-3">
                                      <label className="col-5 fw-bold fs-3">Mobile No:</label>
                                      <div className="col-7 fs-3">
                                          {ViewUserDetail.mobile_no || 'N/A'}
                                      </div>
                                  </div>
                                  <div className="row mb-3">
                                      <label className="col-5 fw-bold fs-3">Permissions:</label>
                                      <div className="col-7 fs-3">
                                          <div>
                                         All
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
        )}

        {/* Render the organization data in a tree structure */}
        {ViewAllOrganisationUserDetail && (
          <div className="organisation-details mt-4">
            <h5 className="mb-3">Organisation Details</h5>
            <div className="tree-container">
              {ViewAllOrganisationUserDetail.map((organisation) => (
                <div key={organisation.id} className="tree-item">
                  <div className="tree-item-header">
                    <strong>{organisation.name}</strong> - {organisation.city}
                    <span className={`badge ${organisation.status === 1 ? 'bg-success' : 'bg-secondary'} ms-2`}>
                      {organisation.status === 1 ? "Active" : "Inactive"}
                    </span>
                  </div>
                  <div className="tree-item-body ms-4">
                    <p><strong>Email:</strong> {organisation.email || 'N/A' }</p>
                    <p><strong>Status:</strong> {organisation.status === 1 ? "Active" : "Inactive"}</p>
                    {organisation.applications && organisation.applications.length > 0 && (
                      <div>
                        <strong>Applications:</strong>
                        {renderApplications(organisation.applications)}
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default ViewOwnerUserDetail;
